import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormattedMessage } from 'react-intl';

class ChangeRsvpModal extends React.Component {
  render () {
    const { handleChangeResponseModal } = this.props;

    return (
      <BootstrapModal
        {...this.props}
        ref="ChangeRsvpModal"
        body={
          <div className="ChangeRsvpModal">
            <h3 className="text-center">
              <FormattedMessage id="invite.change_rsvp_modal.change_response" defaultMessage="Change your response" />
            </h3>

            <p className="text-large text-center">
              <FormattedMessage
                id="invite.change_rsvp_modal.let_know"
                defaultMessage="Let {name} know if you can make it"
                values={{
                  name: this.props.guestFirstName
                }}
              />
            </p>

            <div className="accept text-center">
              <button className="accept-btn btn btn-primary" onClick={handleChangeResponseModal('going')}>
                <FormattedMessage id="invite.change_rsvp_modal.accept_invitation" defaultMessage="Accept Invitation" />
              </button>
            </div>

            <div className="decline text-center">
              <button className="decline-btn btn-link-primary" onClick={handleChangeResponseModal('not_going')}>
                <FormattedMessage id="invite.change_rsvp_modal.decline_invitation" defaultMessage="Decline" />
              </button>
            </div>
          </div>
        }
      />
    );
  }
}

ChangeRsvpModal.propTypes = {
  handleChangeInvitation: PropTypes.func,
  guestFirstName: PropTypes.string,
  closeModal: PropTypes.func
};

export default ChangeRsvpModal;
